<template>
  <carousel
    :per-page="perPage"
    :loop="true"
    navigation-next-label="<span class='iconmoon-rightarrow'></span>"
    navigation-prev-label="<span class='iconmoon-leftarrow'></span>"
    :navigation-enabled="true"
    pagination-active-color="#c80004"
    pagination-color="#fff"
    class="carouser-wrapper"
  >
    <slot></slot>
  </carousel>
</template>

<script>
export default {
  name: "app-gallery",
  props: {
    perPage: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style lang="scss">
@import "./../../../../assets/styles/vars";

.VueCarousel-pagination {
  position: absolute;
  bottom: 0%;
}

.VueCarousel-navigation-button {
  display: none;
  font-size: 56px;
  color: #c70004 !important;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.6) !important;

  @media (max-width: $screen-sm-max) {
    font-size: 40px;
  }
}

.VueCarousel:hover,
.VueCarousel:focus {
  .VueCarousel-navigation-button {
    display: block !important;
  }
}

.VueCarousel-navigation-prev {
  transform: translateY(-50%) translateX(0%) !important;

  @media (max-width: $screen-xs) {
    font-size: 28px;
  }
}

.VueCarousel-navigation-next {
  transform: translateY(-50%) translateX(0) !important;

  @media (max-width: $screen-xs) {
    font-size: 28px;
  }
}
</style>
